import { inWindow } from 'api';
import { config as envDefConfig } from 'env_def';
export var CURRENCY_MAP;
(function (CURRENCY_MAP) {
    CURRENCY_MAP["CNY\u4EBA\u6C11\u5E01"] = "\uFFE5";
    CURRENCY_MAP["USD\u7F8E\u91D1"] = "$";
    CURRENCY_MAP["USD\u7F8E\u5143"] = "$";
    CURRENCY_MAP["AUD\u6FB3\u5143"] = "$";
    CURRENCY_MAP["CAD\u52A0\u5143"] = "C$";
    CURRENCY_MAP["EUR\u6B27\u5143"] = "\u20AC";
    CURRENCY_MAP["KRW\u97E9\u5143"] = "\u20A9";
    CURRENCY_MAP["GBP\u82F1\u9551"] = "\u00A3";
    CURRENCY_MAP["CHF\u745E\u58EB\u6CD5\u90CE"] = "CHF";
    CURRENCY_MAP["HKD\u6E2F\u5E01"] = "HK$";
    CURRENCY_MAP["IDR\u5370\u5C3C\u5362\u6BD4"] = "Rs";
    CURRENCY_MAP["INR\u5370\u5EA6\u5362\u6BD4"] = "\u20B9";
    CURRENCY_MAP["JPY\u65E5\u5143"] = "\u00A5";
    CURRENCY_MAP["MYR\u9A6C\u6765\u897F\u4E9A\u6797\u5409\u7279"] = "RM";
    CURRENCY_MAP["MYR\u739B\u62C9\u897F\u4E9A\u6797\u5409\u7279"] = "RM";
    CURRENCY_MAP["NZD\u65B0\u897F\u5170\u5143"] = "NZ$";
    CURRENCY_MAP["PHP\u83F2\u5F8B\u5BBE\u6BD4\u7D22"] = "\u20B1";
    CURRENCY_MAP["RUB\u4FC4\u7F57\u65AF\u5362\u5E03"] = "\u20BD";
    CURRENCY_MAP["SGD\u65B0\u52A0\u5761\u5143"] = "S$";
    CURRENCY_MAP["THB\u6CF0\u94E2"] = "\u0E3F";
    CURRENCY_MAP["TWD\u65B0\u53F0\u5E01"] = "NT$";
})(CURRENCY_MAP || (CURRENCY_MAP = {}));
export const EdmEmptyProductPic = 'https://cowork-storage-public-cdn.lx.netease.com/common/2024/06/19/dfbce36b984440f7ab3f822c33dc6ac3.png';
const getUrl = (id) => {
    return envDefConfig('stage') === 'prod' ? `https://site.office.163.com/product/${id}.html` : `https://sirius-it-site.cowork.netease.com/product/${id}.html`;
};
export const getTextContent = (content) => {
    if (inWindow() && typeof content == 'string') {
        const div = document.createElement('div');
        div.innerHTML = content;
        return div.textContent;
    }
    return content !== null && content !== void 0 ? content : '';
};
export const getProductsHtml = (tab, lists, columns, fieldsMap, imgSize, langVal, imgDisplay, siteId) => {
    let subHtml = '';
    const judgeLang = (key) => {
        var _a, _b;
        if (langVal === '') {
            return (_a = fieldsMap[key]) === null || _a === void 0 ? void 0 : _a.label;
        }
        else {
            return (_b = fieldsMap[key]) === null || _b === void 0 ? void 0 : _b[langVal];
        }
    };
    if (tab === 0) {
        let column = 5;
        if (imgSize == 150) {
            column = 4;
        }
        else if (imgSize == 200) {
            column = 3;
        }
        const l = lists.length;
        while (l < 10 && l % column > 0 && l % column <= column / 2) {
            column--;
        }
        const showPrice = columns.includes('price');
        const render = (item, index) => {
            var _a;
            const columnKey = columns[index];
            if (!columnKey) {
                return '';
            }
            let text = (_a = item[columnKey]) !== null && _a !== void 0 ? _a : '';
            if (columnKey == 'product_description_en') {
                text = getTextContent(text);
            }
            else if (columnKey === 'price') {
                text = item['priceRange'] || text;
                if (text) {
                    const currency = item['price_currency'];
                    const currencyIcon = currency ? CURRENCY_MAP[currency] || '$' : '$';
                    text = currencyIcon + text;
                }
            }
            return ['product_name_cn', 'product_name_en'].includes(columnKey)
                ? `<a style="display:inline-block;width:100%;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" href="${item.productLink || getUrl(item.id)}">${text}</a>`
                : `<div style="width: 100%;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${text}</div>`;
        };
        const renderPrice = (item) => {
            var _a;
            const columnKey = 'price';
            let text = (_a = item[columnKey]) !== null && _a !== void 0 ? _a : '';
            text = item['priceRange'] || text;
            if (text) {
                const currency = item['price_currency'];
                const currencyIcon = currency ? CURRENCY_MAP[currency] || '$' : '$';
                text = currencyIcon + text;
            }
            return `<div style="width: 100%;overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #4c6aff; font-weight: 500; font-size: 14px;">${text}</div>`;
        };
        const renderName = (item) => {
            const imgColumnsSet = new Set(columns);
            const enText = item['product_name_en'] || '';
            const cnText = item['product_name_cn'] || '';
            const showEn = imgColumnsSet.has('product_name_en');
            const showCn = imgColumnsSet.has('product_name_cn');
            const text = showEn && showCn ? `${cnText}(${enText})` : showEn ? enText : showCn ? cnText : '';
            return (text &&
                `<div style="width: 100%; display: -webkit-box; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; color: #272e47; font-weight: 500; font-size: 14px; line-height: 22px;">${text}</div>`);
        };
        const renderOther = (item) => {
            const result = [];
            columns
                .filter(i => !['price', 'product_name_cn', 'product_name_en'].includes(i))
                .forEach((key, _) => {
                let text = item[key] || '';
                if (key == 'product_description_en') {
                    text = getTextContent(text);
                }
                result.push(text);
            });
            return `<div style="width: 100%;overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; color: #747a8c; font-weight: 400; line-height: 20px; font-size: 12px; margin-top: 4px;">${result
                .filter(i => !!i)
                .join(',')}</div>`;
        };
        let contentHtml = '';
        lists.forEach((item, index) => {
            var _a, _b;
            const column1 = `${renderName(item)}`;
            const otherColumns = `${renderOther(item)}`;
            const column4 = showPrice ? `<div style="font-size: 12px; line-height: 16px; color: #747A8C; margin-top: 10px">${renderPrice(item)}</div>` : '';
            contentHtml += `<a contenteditable="false"
      href="${item.productLink || getUrl(item.id)}"
      style="width: ${imgSize}px; font-weight: 400; color: #232D47;display: inline-block; margin: 10px; padding: 16px; border: 1px solid #EBEDF2; border-radius: 4px; background-color: #fff; text-decoration: unset; cursor: pointer">
        <div
          class="sirius-product-item"
          data-id="${(item === null || item === void 0 ? void 0 : item.id) || (item === null || item === void 0 ? void 0 : item.product_id)}"
          data-link="${item.productLink || getUrl(item.id)}"
          data-siteId="${siteId}">
          <img style="margin-bottom:8px;object-fit:${imgDisplay}" width=${imgSize} height=${imgSize} src=${((_b = (_a = item.pictures) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url) || EdmEmptyProductPic} />
      </div>
      ${column1}
      ${otherColumns}
      ${column4}
      </a>`;
            if (index % column == column - 1 && index < l - 1) {
                contentHtml += `<br />`;
            }
        });
        subHtml = `<div style="min-width: ${column * (imgSize + 32) - 32 + 42}px;">${contentHtml}</div>`;
    }
    else {
        let theadHtml = '';
        columns.forEach((key, index) => {
            theadHtml += `<th style="width:130px; text-align:left; padding:${index === 0 ? '12px 20px 12px 24px;' : '12px 20px 12px 0'}">${judgeLang(key)}</th>`;
        });
        let tbodyHtml = '';
        lists.forEach(item => {
            let tdHtml = '';
            columns.forEach((key, index) => {
                const columnKey = columns[index];
                let text = item[columnKey];
                if (columnKey == 'product_description_en') {
                    text = getTextContent(text);
                }
                else if (columnKey === 'price') {
                    text = item['priceRange'] || text;
                    if (text) {
                        const currency = item['price_currency'];
                        const currencyIcon = currency ? CURRENCY_MAP[currency] || '$' : '$';
                        text = currencyIcon + text;
                    }
                }
                text = text !== null && text !== void 0 ? text : '-';
                const overflowStyle = 'white-space: pre-wrap; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2;';
                tdHtml += ['product_name_cn', 'product_name_en'].includes(key)
                    ? `<td style="width:130px; height: 44px; padding:${index === 0 ? '12px 20px 12px 24px;' : '12px 20px 12px 0'}">
    <a href='${item.productLink || getUrl(item.id)}'
    class="sirius-product-item"
    data-id="${(item === null || item === void 0 ? void 0 : item.id) || (item === null || item === void 0 ? void 0 : item.product_id)}"
    data-link="${item.productLink || getUrl(item.id)}"
    data-siteId="${siteId}"
    style="${overflowStyle}">${text}</a></td>`
                    : `<td style="width:130px; height:44px; padding:${index === 0 ? '12px 20px 12px 24px;' : '12px 20px 12px 0'}">
     <span style="${overflowStyle}">${text}</span></td>`;
            });
            tbodyHtml += `<tr style="border-bottom: solid 1px #f0f3f5; line-height: 22px;">${tdHtml}</tr>`;
        });
        subHtml = `<table style="border-collapse:collapse; table-layout:fixed; font-size:14px; width:${columns.length * 130 + 48}px;">
  <thead style="background: #F9FAFB; line-height:22px; color:#747A8C;">
    <tr>${theadHtml}</tr>
  </thead>
  <tbody style="color: #272E47;">${tbodyHtml}</tbody>
</table>`;
    }
    return `<div class="sirius-product-table">${subHtml}</div><br />`;
};
export const getLandingPageHtml = (lists, imgSize) => {
    let subHtml = '';
    let column = 5;
    if (imgSize == 150) {
        column = 4;
    }
    else if (imgSize == 200) {
        column = 3;
    }
    const l = lists.length;
    while (l < 10 && l % column > 0 && l % column <= column / 2) {
        column--;
    }
    const render = (item) => {
        return `<a style="display:inline-block;width:100%;overflow: hidden;
      text-overflow: ellipsis;font-size: 14px;color: #272E47;
      white-space: nowrap;text-align: center;text-decoration: none;" href="${item.indexUrl}">${item.pageName}</a>`;
    };
    let contentHtml = '';
    lists.forEach((item, index) => {
        contentHtml += `<div contenteditable="false"
    style="width: ${imgSize}px; font-weight: 400; color: #232D47; border: 1px solid #EBEDF2; border-radius: 4px; display: inline-block; margin: 16px;">
      <a href="${item.indexUrl}"
        class="sirius-landing-page-item"
        data-id="${item.pageId}"
        data-link="${item.indexUrl}">
        <img style="object-fit:cover;" width=${imgSize} height=${imgSize} src=${item.thumbnail || EdmEmptyProductPic} />
    </a>
    <div style="font-size: 14px; line-height: 22px; height: 22px;padding: 0 6px 6px;">${render(item)}</div>
    </div>`;
        if (index % column == column - 1 && index < l - 1) {
            contentHtml += `<br />`;
        }
    });
    subHtml = `<div style="min-width: ${column * (imgSize + 32) - 32 + 42}px;">${contentHtml}</div>`;
    return `<div class="sirius-landing-page-table">${subHtml}</div><br />`;
};
